import Resource from './Resource'

export interface IWorkingDayType {
  id: string
  legal_entity_id: string
  name: string
  default: true
  archived: false
}
class WorkingDayType extends Resource {
  static urlRoot() {
    return '/contracts/spain/working_day_types'
  }
}

export default WorkingDayType
